<template>
  <div>
    <el-popover v-model="visible" placement="top-start" trigger="click">
      <rtc-switch class="rtc-switch"></rtc-switch>
      <animation-switch></animation-switch>
      <change-fontsize></change-fontsize>
      <el-button
        type="button"
        class="btn-black"
        v-if="isAdmin"
        @click="showBlackList()"
        >小黑屋管理</el-button
      >
      <el-button class="btn-switch" slot="reference">设置</el-button>
    </el-popover>
    <black-user-list ref="blackUserList"></black-user-list>
  </div>
</template>
<script>
import RtcSwitch from './rtc-switch.vue';
import AnimationSwitch from './animation-switch.vue';
import ChangeFontsize from './change-fontsize.vue';
import BlackUserList from './black-user-list.vue';
export default {
  name: 'Setting',
  components: {
    RtcSwitch,
    AnimationSwitch,
    ChangeFontsize,
    BlackUserList
  },
  props: {
    isAdmin: {
      type: [Boolean],
      default: false
    }
  },
  data() {
    return {
      visible: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    showBlackList() {
      this.visible = false;
      this.$refs.blackUserList.show();
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-black {
  margin-top: 20px;
}
.btn-switch {
  background: rgba(255, 255, 255, 0.12);
  color: white;
  font-size: 14px;
  border-radius: 42px;
  padding: 0 28px 0 28px;
  border: none;
  margin-right: 10px;
  /deep/ span {
    display: flex;
    align-items: center;
    height: 44px;
  }
}
</style>
